export const enum DropdownViewStoreEvent {
  change = 'change',
  clickWindow = 'clickWindow',
  close = 'close',
}
